/**
 * Entry point for all public APIs of the package.
 */
export { PersistenceService, AbstractCachedService, StorageType, PersistenceModule } from './src/angular-persistence';

